<div mat-dialog-title class="d-flex justify-content-between align-items-center">
    <h2 class="m-0">Media gallery    </h2>
    <button mat-icon-button mat-dialog-close>
      <mat-icon>close</mat-icon>
    </button>
  </div>
  <mat-dialog-content>
  
    <div>
      <div class="row">
        <div class="col-lg-6 col-md-6 col-sm-12">
          <div class="remove_business_photo">
            <button
            mat-icon-button
            class="profile_button"
            class="share">
            <mat-icon class="material-icons-outlined">more_vert</mat-icon>
          </button>
          <mat-menu #menu="matMenu">
            <button mat-menu-item>
              <mat-icon class="material-icons-outlined">wallpaper</mat-icon>
              <span class="menu_text">Set as default</span>
            </button>
            <button mat-menu-item>
              <mat-icon class="material-icons-outlined">delete</mat-icon>
              <span class="menu_text">deletes</span>
            </button>
          </mat-menu>
        </div>
        <div class="gallery_img_div">
            <img src="https://images.pexels.com/photos/705255/pexels-photo-705255.jpeg" alt="" class="gallery_img">
          </div>
          
        </div>
        <div class="col-lg-6 col-md-6 col-sm-12">
            <div class="remove_business_photo">
              <button
              mat-icon-button
              class="profile_button"
              class="share">
              <mat-icon class="material-icons-outlined">more_vert</mat-icon>
            </button>
            <mat-menu #menu="matMenu">
              <button mat-menu-item>
                <mat-icon class="material-icons-outlined">wallpaper</mat-icon>
                <span class="menu_text">Set as default</span>
              </button>
              <button mat-menu-item>
                <mat-icon class="material-icons-outlined">delete</mat-icon>
                <span class="menu_text">deletes</span>
              </button>
            </mat-menu>
          </div>
          <div class="gallery_img_div">
              <img src="https://5.imimg.com/data5/RK/KI/MY-48428862/salon-interior-designing.jpg" alt="" class="gallery_img">
            </div>
            
          </div>
          <div class="col-lg-6 col-md-6 col-sm-12">
            <div class="remove_business_photo">
              <button
              mat-icon-button
              class="profile_button"
              class="share">
              <mat-icon class="material-icons-outlined">more_vert</mat-icon>
            </button>
            <mat-menu #menu="matMenu">
              <button mat-menu-item>
                <mat-icon class="material-icons-outlined">wallpaper</mat-icon>
                <span class="menu_text">Set as default</span>
              </button>
              <button mat-menu-item>
                <mat-icon class="material-icons-outlined">delete</mat-icon>
                <span class="menu_text">deletes</span>
              </button>
            </mat-menu>
          </div>
          <div class="gallery_img_div">
              <img src="https://www.shutterstock.com/image-illustration/luxury-pink-beauty-care-salon-600nw-2319523823.jpg" alt="" class="gallery_img">
            </div>
            
          </div>
          <div class="col-lg-6 col-md-6 col-sm-12">
            <div class="remove_business_photo">
              <button
              mat-icon-button
              class="profile_button"
              class="share">
              <mat-icon class="material-icons-outlined">more_vert</mat-icon>
            </button>
            <mat-menu #menu="matMenu">
              <button mat-menu-item>
                <mat-icon class="material-icons-outlined">wallpaper</mat-icon>
                <span class="menu_text">Set as default</span>
              </button>
              <button mat-menu-item>
                <mat-icon class="material-icons-outlined">delete</mat-icon>
                <span class="menu_text">deletes</span>
              </button>
            </mat-menu>
          </div>
          <div class="gallery_img_div">
              <img src="https://img-us.didaudo.net/us-locations/US/000/004/4402/16anonymous-hair-salon0.jpg?output=webp&fit=cover&w=800&h=600" alt="" class="gallery_img">
            </div>
            
          </div>
      </div>
    </div>
  
 
  
  </mat-dialog-content>
